import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { API_URL, Currency, FormatNumber, config, UserCode, PKLIVE, FLPKEY, API_IMAGES } from '../../../components/Include';
import { Alerts } from '../../../components/notify';
import { getBritishDate } from '../../../components/GlobalFunction';
import { usePaystackPayment } from 'react-paystack';
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import './change-skill.css';

import Select from 'react-select'
import { styles } from '../../../components/GlobalFunction';

// ============================================================
// CHANGE SKILL PAYMENT SWITCH
// false = payment is disabled, students change skill for free
// true  = students must pay the change skill fee (Paystack)
// ============================================================
const REQUIRE_CHANGE_SKILL_PAYMENT = false;

// Define interface for skill change history item
interface SkillChangeHistory {
  id: string;
  requestDate: string;
  paymentReference: string;
  previousSkill: string;
  requestedSkill: string;
  status: 'pending' | 'approved' | 'rejected';
  approvalDate?: string;
  rejectionReason?: string;
}

const ChangeSkill = () => {
  // State management
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [currentSkill, setCurrentSkill] = useState<any>(null);
  const [availableSkills, setAvailableSkills] = useState<any[]>([]);
  const [selectedSkill, setSelectedSkill] = useState<any>(null);
  const [activePaymentMethod, setActivePaymentMethod] = useState<string>('Paystack');
  const [paymentReference, setPaymentReference] = useState<string>('');
  const [requestStatus, setRequestStatus] = useState<string>('pending');
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [changeSkillFee] = useState<number>(1000);
  const [changeHistory, setChangeHistory] = useState<SkillChangeHistory[]>([]);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [calculatedAmount, setCalculatedAmount] = useState(0);
  const [courses, setCourses] = useState([] as any);
  // Get student data from Redux store
  const student = useSelector((state: any) => state.rootReducer.student);
  const [list, setList] = useState({
    course_code:[] as any,
  });
  // Payment processing functions



  const FetchHistory = () => {
    setLoading(true);
    const url = API_URL + '/student/course_record/' + UserCode
    
    axios.get(url, config)
      .then((response:any) => {

       
        if (response.data.status === 200) {
          const cs = response.data.data.filter((item:any)=>item.course_status ==='Active')
          setCourses(cs);

        }
      })
      .catch((error) => {
        Alerts('danger', error.message, 'Something went wrong!');
      })
      .finally(() => {
        setLoading(false);
      });
  };



  const handleSelect = (option:any, action:any)=>{

    setList({...list, [action.name]:option});

    fetchAvailableSkills(option.value);
  
     }



 

  const handlePaystackFees =()=>{
var amount = 0
    var amountToCharge = (0.015 * Number(changeSkillFee)) + 300
if(Number(changeSkillFee) <2500){

    amount =  (Number(changeSkillFee)+ (amountToCharge)) * 100

}else if(amountToCharge>2000){
        amount = (Number(changeSkillFee)+ (2000)) * 100
    }else{
        
    amount =  (Number(changeSkillFee)+ (amountToCharge+100)) * 100
    }
    return amount; 

    
}


  const handleFlutterwaveFees = () => {
    const amountToCharge = (0.038 * changeSkillFee);
    const amount = (changeSkillFee + amountToCharge);
    return amount;
  };
  
  
  let amountToPay = activePaymentMethod === 'Paystack' ? handlePaystackFees() : handleFlutterwaveFees();
  const txRef = (new Date()).getTime().toString();
  
  
  useEffect(() => {
    const newAmount = activePaymentMethod === 'Paystack' ? handlePaystackFees() : handleFlutterwaveFees();
    setCalculatedAmount(newAmount);
  }, [activePaymentMethod, changeSkillFee]);
  
  
  useEffect(() => {
    if (calculatedAmount > 0) {
      amountToPay = calculatedAmount;
    }
  }, [calculatedAmount]);
  
  


  const paystackConfig = {
    reference: txRef,
    email: student.email_address,
    firstname:student.full_name + ' '+ student.matric_no,
    lastname:student.telephone,
    phone:UserCode,
    amount: amountToPay,
    publicKey: PKLIVE,
    split_code:'SPL_5Yq0hYZqiv'
    };

  const initializePayment = usePaystackPayment(paystackConfig);
  
  const flutterConfig = {
    public_key: FLPKEY,
    tx_ref: txRef,
    amount: amountToPay,
    currency: "NGN",
    country: "NG",
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: student.email_address,
      phone_number: UserCode ||"",
      name: student.full_name +  student.telephone + ' '+ student.matric_no,
    },
    customizations: {
      title: 'Entrepreneurship Development Center, NSUK',
      description: 'Change Skill Fee',
      logo: API_IMAGES+'/edc.jpg',
    },
    subaccounts: [
      {
        id: "RS_1A69795ABBEA25EE8B1E73C11688532E",
        transaction_split_ratio: "10"
      },
      {
        id: "RS_BD2F1A4916F6BE96DA7A6118660E4A3F",
        transaction_split_ratio: "10"
      }
    ]
  };
  
  const handleFlutterPayment = useFlutterwave(flutterConfig);
  
  const handleFlutterPay = () => {
    handleFlutterPayment({
      callback: (response) => {
        if (response.status === "successful") {
          handlePaymentSuccess('Flutterwave', String(response.transaction_id));
        } else {
          window.location.reload();
        }
      },
      onClose: () => {
        closePaymentModal();
      },
    });
  };

  
  
  const onSuccess = (reference: any) => {
    handlePaymentSuccess('Paystack', reference.reference);
  };
  
  const onClose = () => {
    console.log('Payment closed');
  };

  // Used when REQUIRE_CHANGE_SKILL_PAYMENT is false
  const handleFreeSubmit = () => {
    handlePaymentSuccess('Free', 'FREE-' + txRef);
  };
  
  const handlePaymentSuccess = ( gateway: string, reference: string) => {

    setLoading(true);
      const fd = new FormData();
     
fd.append('student_code', student.code);
fd.append('payment_ref', reference);
fd.append('transaction_id', txRef);
fd.append('old_skill', list.course_code.skill_code);
fd.append('new_skill', selectedSkill.skill_code);
fd.append('amount_paid', REQUIRE_CHANGE_SKILL_PAYMENT ? String(changeSkillFee) : '0'); 
fd.append('platform', gateway);
fd.append('payment_status', REQUIRE_CHANGE_SKILL_PAYMENT ? 'paid' : 'waived');  
fd.append('application_code', list.course_code.value);


      let url = API_URL+'/student/payment/change-skill';
        axios.post(url, fd, config).then((response:any)=>{
          
          if(response.data.status ===200){
            setLoading(false);
      Alerts('success', response.data.message, 'Success')
      setPaymentReference(reference);
      setCurrentStep(3);


          }else{
            Alerts('danger', response.data.message, 'Something went wrong')
            setInterval(()=>{
             // window.location.reload();
            }, 3000)
          }
        })
        .catch((error)=>{
          Alerts('danger', error.message, 'Error')
          setInterval(()=>{
            //window.location.reload();
          }, 3000)
        }).finally(()=>{
          setLoading(false);
        }) 
      
  };

  

  useEffect(()=>{
    FetchHistory();
    fetchChangeHistory();
  },[])


  const fetchChangeHistory = async () => {

      try {
        const fd = new FormData();
        fd.append('student_code', String(UserCode));
      
      const url = API_URL + '/student/skill_change/change-history';
  
        const response = await  axios.post(url, fd, config)
        if (response.data.status === 200) {

          setChangeHistory(response.data.data);
  
        }
    } catch (error: any) {
      Alerts('danger', error.message, 'Error fetching change history');
    } 
  }



  const fetchAvailableSkills = (code: string) => {
    setLoading(true);
    const fd = new FormData();

    fd.append('course_code', code);
    fd.append('study_mode', student.study_mode);
    fd.append('student_code', student.code);
    fd.append('faculty', student.faculty);

    const url = API_URL + '/student/application/change-skill';
    axios.post(url, fd, config)
      .then((response: any) => {
        if (response.data.status === 200) {
         
          const data = response.data.data;
          setAvailableSkills(data);
          

        } else {
          setAvailableSkills([])
          
          Alerts('danger', response.data.message, 'Something went wrong!');
          
              }
      })
      .catch((error) => {
        Alerts('danger', error.message, 'Something went wrong!');
      })
      .finally(() => {
        setLoading(false);
        setCurrentStep(1)
          setSelectedSkill(null)
      });
  };



  // Filter skills based on search query
  const filteredSkills = availableSkills.filter(skill => 
    skill.title.toLowerCase().includes(searchQuery.toLowerCase())
  );




  const handleSkillSelect = (skill: any) => {
    setSelectedSkill(skill);
  };

 

  const toggleHistory = () => {
    setShowHistory(!showHistory);
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };



  const handleNext = () => {
    if (currentStep === 1) {
      if (selectedSkill) {
        setCurrentStep(2);
      } else {
        Alerts('warning', 'Please select a skill before proceeding', 'Skill Selection Required');
      }
    } else if (currentStep === 2) {
      //handlePaymentSubmit();
    }
  };

  const getSlotStatusClass = (total: number, applied: number) => {
    const remaining = total - applied;
    const percentage = (remaining / total) * 100;
    
    if (percentage <= 25) return 'low';
    if (percentage <= 50) return 'medium';
    return 'high';
  };


  const renderStepIndicator = () => {
    return (
      <div className="change-skill-steps">
        
        <div className={`change-skill-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}>
          <div className="change-skill-step-circle">
            {currentStep > 1 ? <i className="fa fa-check"></i> : 1}
          </div>
          <div className="change-skill-step-label">Select New Skill</div>
        </div>


        
        <div className={`change-skill-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}>
          <div className="change-skill-step-circle">
            {currentStep > 2 ? <i className="fa fa-check"></i> : 2}
          </div>
          <div className="change-skill-step-label">{REQUIRE_CHANGE_SKILL_PAYMENT ? 'Make Payment' : 'Confirm Change'}</div>
        </div>
        
     
        
        <div className={`change-skill-step ${currentStep >= 3 ? 'active' : ''}`}>
          <div className="change-skill-step-circle">3</div>
          <div className="change-skill-step-label">Request Status</div>
        </div>
      </div>
    );
  };

  const renderConfirmStep = () => {
    return (
      <div className="change-skill-panel">
        <h5><i className="fa fa-check-circle"></i> Confirm Skill Change</h5>

        <div className="change-skill-alert">
          <i className="fa fa-info-circle"></i>
          <p>
            You are about to change your skill to <strong>{selectedSkill?.title}</strong>. 
            No payment is required for this request.
          </p>
        </div>

{currentSkill?.skill_code === selectedSkill?.skill_code?  <div className="change-skill-alert mt-5">
          <i className="fa fa-info-circle"></i>
          <p>
            Please select a different skill from the options to proceed.
          </p>
        </div>:
        <button className="payment-button" onClick={handleFreeSubmit} disabled={loading}>
          <i className="fa fa-check"></i>
          Submit Change Request
        </button>}
      </div>
    );
  };

  const renderPaymentStep = () => {
    if (!REQUIRE_CHANGE_SKILL_PAYMENT) {
      return renderConfirmStep();
    }
    return (
      <div className="change-skill-panel">
        <h5><i className="fa fa-credit-card"></i> Payment for Skill Change</h5>
        
        <div className="change-skill-alert">
          <i className="fa fa-info-circle"></i>
          <p>
            You are about to change your skill  to <strong>{selectedSkill?.title}</strong>. 
            A fee of {Currency}{FormatNumber(changeSkillFee)} is required to process this request.
          </p>
        </div>
        
        <div className="payment-amount">
          {Currency}{FormatNumber(changeSkillFee)}
        </div>
        
        <h6>Select Payment Method</h6>
        
        {/* Payment Methods */}
        <div className="payment-methods">
          <div
            className={`payment-method-card ${activePaymentMethod === 'Paystack' ? 'active' : ''}`}
            onClick={() => setActivePaymentMethod('Paystack')}
          >
            <div className="card-icon">
              <i className="fa fa-credit-card"></i>
            </div>
            <h5>Paystack</h5>
            <p>Pay with card, bank transfer or USSD</p>
          </div>

        
        </div>

        {/* Payment Summary */}
        <div className="payment-summary">
          <div className="summary-item">
            <span>Base Amount:</span>
            <span>
              {Currency}
              {FormatNumber(changeSkillFee || 0)}
            </span>
          </div>
          <div className="summary-item">
            <span>Processing Fee:</span>
            <span>
              {Currency}
              {activePaymentMethod === 'Paystack'
                ? FormatNumber((amountToPay / 100) - changeSkillFee)
                : FormatNumber(amountToPay - changeSkillFee)}
            </span>
          </div>
          <div className="summary-item total">
            <span>Total:</span>
            <span>
              {Currency}
              {activePaymentMethod === 'Paystack'
                ? FormatNumber(amountToPay / 100)
                : FormatNumber(amountToPay)}
            </span>
          </div>
        </div>

        {/* Payment Button */}



{currentSkill?.skill_code === selectedSkill?.skill_code?  <div className="change-skill-alert mt-5">
          <i className="fa fa-info-circle"></i>
          <p>
            Please select a different skill from the options to proceed.
          </p>
        </div>:<div>
       

     


        {activePaymentMethod === 'Paystack' ? (
         <button
            className="payment-button"
            onClick={() => initializePayment({ onSuccess, onClose })}
          >
            <i className="fa fa-lock"></i>
            Pay Now with Paystack
            <span>{Currency}{FormatNumber(amountToPay / 100)}</span>
          </button> 


        ) : (
          <button className="payment-button" onClick={handleFlutterPay}>
            <i className="fa fa-lock"></i>
            Pay Now with Flutterwave
            <span>{Currency}{FormatNumber(amountToPay)}</span>
          </button>
        )}
</div>}
      </div>
    );
  };

  // Render skill selection step
  const renderSkillSelectionStep = () => {
    return (
      <div className="change-skill-panel">
        <h5><i className="fa fa-graduation-cap"></i> Select New Skill</h5>
        
        <div className="change-skill-alert">
          <i className="fa fa-info-circle"></i>
          <p>
            Please select a skill from the options below to proceed. You must select a skill before you can continue{REQUIRE_CHANGE_SKILL_PAYMENT ? ' to payment' : ''}.
          </p>
        </div>
        
        {/* Search input */}
        <div className="input-group mb-3">
          <span className="input-group-text">
            <i className="fa fa-search"></i>
          </span>
          <input 
            type="text" 
            className="form-control" 
            placeholder="Search for skills..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        
        {/* Skills grid */}
        <div className="skill-cards">
          {filteredSkills.map((skill) => {
            
             const remainingSlots = Number(skill.slot) - Number(skill.applied);
                const slotStatusClass = getSlotStatusClass(Number(skill.slot), Number(skill.applied));
            
            return  remainingSlots>0&&  (
            <div 
              key={skill.skill_code} 
              className={`skill-card ${selectedSkill&&selectedSkill?.skill_code === skill.skill_code ? 'selected active' : ''}`}
              onClick={() => handleSkillSelect(skill)}
            >
              <div className="skill-card-img">
                <img  src={API_IMAGES + '/skill/' + skill.image} 
                        onError={(e) => {
                          (e.target as HTMLImageElement).onerror = null; 
                          (e.target as HTMLImageElement).src = API_IMAGES + '/no.jpg';
                        }} 
                        alt={skill.title} />
                <span className="skill-card-badge">{skill.category}</span>
              </div>
              <div className="skill-card-content">
                <h5 className="skill-card-title">{skill.title}</h5>
               
               <div className={`skill-slots ${slotStatusClass}`}>
                        <i className="fa fa-users"></i> {remainingSlots} slots
                      </div> 

             {/*    <div className="skill-card-slots">
                  <div 
                    className={`skill-card-slots-indicator ${getSlotAvailabilityClass(skill.available_slot, skill.total_slot)}`}
                  ></div>
                  <span className="skill-card-slots-text">
                    {skill.slot-skill.applied} slots left
                  </span>
                </div> */}
              </div>
            </div>
          )})}
          
          {filteredSkills.length === 0 && (
            <div className="alert alert-info w-100">
              No skills found matching your search criteria.
            </div>
          )}
        </div>
      </div>
    );
  };

  // Render request status step
  const renderRequestStatusStep = () => {
    return (
      <div className="change-skill-panel">
        <div className="request-status">

          <div className={`request-status-icon ${requestStatus}`}>
            {requestStatus === 'pending' && <i className="fa fa-clock"></i>}
            {requestStatus === 'approved' && <i className="fa fa-check-circle"></i>}
            {requestStatus === 'rejected' && <i className="fa fa-times-circle"></i>}
          </div>
          
          <h3 className="request-status-title">
            {requestStatus === 'pending' && 'Request Pending'}
            {requestStatus === 'approved' && 'Request Approved'}
            {requestStatus === 'rejected' && 'Request Rejected'}
          </h3>
          
          <p className="request-status-message">
            {requestStatus === 'pending' && 'Your skill change request is being reviewed by an administrator.'}
            {requestStatus === 'approved' && 'Your skill change request has been approved.'}
            {requestStatus === 'rejected' && 'Your skill change request has been rejected.'}
          </p>
          
          <div className="request-status-details">
            <div className="request-summary">
              <div className="request-summary-item">
                <span className="request-summary-label">Request Date</span>
                <span className="request-summary-value">{getBritishDate(new Date().toISOString())}</span>
              </div>
              
              <div className="request-summary-item">
                <span className="request-summary-label">Payment Reference</span>
                <span className="request-summary-value">{paymentReference}</span>
              </div>
              
              <div className="request-summary-item">
                <span className="request-summary-label">Current Skill</span>
                <span className="request-summary-value">{list.course_code.title}</span>
              </div>
              
              <div className="request-summary-item">
                <span className="request-summary-label">Requested Skill</span>
                <span className="request-summary-value">{selectedSkill?.title}</span>
              </div>
              
              <div className="request-summary-item">
                <span className="request-summary-label">Status</span>
                <span className="request-summary-value">
                  <span className={`badge bg-${requestStatus === 'pending' ? 'warning' : requestStatus === 'approved' ? 'success' : 'danger'}`}>
                    {requestStatus.toUpperCase()}
                  </span>
                </span>
              </div>
            </div>
          </div>
          
          <div className="history-toggle-container">
            <button 
              className="btn-history-toggle" 
              onClick={toggleHistory}
            >
              {showHistory ? 'Hide Change History' : 'View Change History'} 
              <i className={`fa fa-${showHistory ? 'chevron-up' : 'chevron-down'}`}></i>
            </button>
          </div>
          
          {showHistory && renderChangeHistory()}
        </div>
      </div>
    );
  };
  
  // Render change history
  const renderChangeHistory = () => {
    return (
      <div className="change-history-container">
        <h4><i className="fa fa-history"></i> Skill Change History</h4>
        
        {changeHistory.length === 0 ? (
          <div className="no-history-message">
            <i className="fa fa-info-circle"></i>
            <p>You have no previous skill change requests.</p>
          </div>
        ) : (
          <div className="change-history-list">
            {changeHistory.map((item, index) => (
              <div key={index} className="change-history-item">
                <div className="change-history-header">
                  <div className="change-history-date">
                    <i className="fa fa-calendar-alt"></i> {getBritishDate(item.requestDate)}
                  </div>
                  <div className="change-history-status">
                    <span className={`badge bg-${item.status === 'pending' ? 'warning' : item.status === 'approved' ? 'success' : 'danger'}`}>
                      {item.status.toUpperCase()}
                    </span>
                  </div>
                </div>
                
                <div className="change-history-details">
                  <div className="change-history-skills">
                    <div className="change-history-from">
                      <span className="history-label">From:</span>
                      <span className="history-value">{item.previousSkill}</span>
                    </div>
                    <div className="change-history-arrow">
                      <i className="fa fa-arrow-right"></i>
                    </div>
                    <div className="change-history-to">
                      <span className="history-label">To:</span>
                      <span className="history-value">{item.requestedSkill}</span>
                    </div>
                  </div>
                  
                  <div className="change-history-reference">
                    <span className="history-label">Reference:</span>
                    <span className="history-value">{item.paymentReference}</span>
                  </div>
                  
                  {item.status === 'rejected' && item.rejectionReason && (
                    <div className="change-history-reason">
                      <span className="history-label">Reason:</span>
                      <span className="history-value">{item.rejectionReason}</span>
                    </div>
                  )}
                  
                  {item.status === 'approved' && item.approvalDate && (
                    <div className="change-history-approval">
                      <span className="history-label">Approved on:</span>
                      <span className="history-value">{getBritishDate(item.approvalDate)}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  // Render action buttons based on current step
  const renderActionButtons = () => {
    // Determine if the button should be disabled
    const isButtonDisabled = 
      loading || 
      (currentStep === 1 && !selectedSkill) || 
      (currentStep === 2 && !activePaymentMethod);
    
    return (
      <div className="change-skill-actions">
        {currentStep > 1 && (
          <button 
            className="btn-change-skill btn-back" 
            onClick={handleBack}
            disabled={loading}
          >
            <i className="fa fa-arrow-left"></i> Back
          </button>
        )}
        
        {currentStep < 2 && (
          <button 
            className="btn-change-skill btn-next" 
            onClick={handleNext}
            disabled={isButtonDisabled}
            style={{ opacity: isButtonDisabled ? 0.6 : 1 }}
          >
            {currentStep === 1 ? (REQUIRE_CHANGE_SKILL_PAYMENT ? 'Proceed to Payment' : 'Continue') : 'Submit Request'} <i className="fa fa-arrow-right"></i>
          </button>
        )}
      </div>
    );
  };





  return (
    <>
      {loading && (
        <div className="overlay">
          <img src="/images/loader.svg" alt="Loading" />
        </div>
      )}
      



 <div className="skills-container  mt-4">
        
        <div className="skills-header">
          <h4>
            <i className="fa fa-briefcase me-2"></i> Choose Course
          </h4>
        </div>

        <div className="skills-content" style={{ minHeight:'300px'}}>

        <section className="col-md-12 ">
 
 <div  className="form-group">
     <label className='text-bold mb-2'>Select Course <span className='text-danger'>*</span></label>

 
<Select  options={
              courses&&courses.map((list:any, idx:number)=> {
              return {key:idx, value: list.code, title:list.title, fees:list.fees, skill_code:list.skill_code, label: list.course_title, course_code:list.course_code, session:list.session}
              })} 
              getOptionLabel={option =>`${option.session} ${option.label} - ${option.course_code}`}
onChange={handleSelect}  
name="course_code"
value={list.course_code} 
styles={styles}
/>
</div>

</section>

        </div>
      </div>



{availableSkills.length>0 && (
      <div className="change-skill-container">

        <div className="skills-header">
          <h4><i className="fa fa-exchange-alt"></i> Change Skill Request</h4>
          
        

         
          {(currentStep === 1 || currentStep === 2) && changeHistory.length > 0 && (
            <button 
              className="btn btn-success" 
              onClick={() => {
                setShowHistory(true);
                setCurrentStep(3);
              }}
            >
              <i className="fa fa-history"></i> View Change History
            </button>
          )}
        </div>

        <div className="change-skill-content">
          {renderStepIndicator()}
          
          {currentStep === 1 && renderSkillSelectionStep() }
          {currentStep === 2 && renderPaymentStep()}
          {currentStep === 3 && renderRequestStatusStep()}
          
          {renderActionButtons()}
        </div>
      </div>)}
    </>
  );
};

export default ChangeSkill;
